<template>
  <v-app :class="{
      'App-galileo': $site === $const.sites.galileo,
      'App-nikon': $site === $const.sites.nikon,
      'App-nikon-it': $site === $const.sites['nikon-it']
    }">
    <CreateAppointment v-if="layout === 'embed'" :eId="qs.eId" :origin="qs.origin" :shopUuid="qs.shopUuid" />
    <Landing v-else-if="layout === 'landing'" :eId="qs.eId" :origin="qs.origin" :shopUuid="qs.shopUuid" />
  </v-app>
</template>

<script>
import CreateAppointment from '@/components/customer/CreateAppointment.old'
import Landing from '@/components/customer/Landing'

export default {
  name: 'App',
  components: {
    CreateAppointment,
    Landing
  },
  computed: {
    layout() {
      return this.$layout
    }
  },
  data() {
    return {
      qs: {}
    }
  },
  mounted() {
    if (this.$site === this.$const.sites.galileo) {
      const favicon = document.getElementById('favicon')
      favicon.href = '/galileo-favicon.ico'
    }
    if ([this.$const.sites['nikon-it'], this.$const.sites.nikon].includes(this.$site)) {
      const favicon = document.getElementById('favicon')
      favicon.href = '/nikon-favicon.png'
    }
    this.qs = window.location.search
      .substr(1)
      .split('&')
      .reduce((o, kv) => {
        const e = kv.split('=')

        return {
          ...o,
          [e[0]]: e[1]
        }
      }, {})
    if (this.qs.origin === 'transitions') {
      const favicon = document.getElementById('favicon')
      favicon.href = '/transitions-favicon.png'
    }
  }
}
</script>
<style lang="scss">
.App-nikon .primaryBtn,
.App-nikon-it .primaryBtn {
  background-color: var(--v-primaryBtn-base) !important;
  border-color: var(--v-primaryBtn-base) !important;
  font-weight: bold !important;
  color: var(--v-secondary-base) !important;
}

.App-nikon .primary,
.App-nikon-it .primary {
  background-color: var(--v-primaryBtn-base) !important;
  border-color: var(--v-primaryBtn-base) !important;
  font-weight: bold !important;
  color: var(--v-secondary-base) !important;
}

.App-nikon .v-picker,
.App-nikon-it .v-picker {
  .v-picker__title {
    background-color: var(--v-primaryCalendar-base) !important;
    color: '#FFFFFF' !important;
  }
  .v-btn--active {
    color: '#FFFFFF' !important;
    background-color: var(--v-primaryCalendar-base) !important;
  }
  .v-btn--outlined {
    color: var(--v-secondary-base) !important;
  }
}
</style>